import SkyWindow from 'sky-window';
import SkyVisible from './sky-visible';

function visibleInit() {
	const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

	// Bind events to window
	SkyWindow.scroll.subscribe(() => {
		SkyVisible.checkViews(false, true);
	});

	SkyWindow.on('orientationchange').subscribe(() => {
		// Recalculate with a 300ms debounce
		SkyVisible.refresh(300);
	});

	SkyWindow.resize.subscribe(() => {
		if (isIOS) {
			SkyVisible.refresh(0);
			return;
		}

		// Recalculate with a 300ms debounce
		SkyVisible.refresh(300);
	});

	// Recalculate on load - debounce 0ms to add at end of callstack
	SkyWindow.load.subscribe(() => {
		SkyVisible.refresh(0);
	});

	document.addEventListener('DOMContentLoaded', () => SkyVisible.refresh());
}

visibleInit();

export default SkyVisible;



// WEBPACK FOOTER //
// ./scripts/sky-visible/index.js